var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeedHelp = function SvgNeedHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#00263E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
    fontSize: 21,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.662,
    y: 20
  }, "?")))));
};
export default SvgNeedHelp;